import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { array, arrayOf, element, func, object, shape, string, node, number, bool, oneOf, oneOfType } from 'prop-types';
import { GenericImageIcon, LogoMagaluDesktop } from '@magalu/stereo-ui-icons';
import { HeaderContainer, HeaderContent, LuContainer, LogoContainer, StyledLogo, LinksContainer, WidgetsContainer, MenusContainer, SearchInputContainer, LoggedAreaContainer, ButtonContainer, StyledStrip, StyledWishlistCounterButton, StyledShoppingBagButton } from './header.styles';
import { HorizontalLinks, LoginMenu, SearchInput } from '../../molecules';
import { LinksMenu, HeaderLinks } from '../../organisms';
import Zipcode from './Zipcode';

const Header = ({
  data,
  searchSuggestions,
  topTermsData,
  isRendered,
  initialValue,
  linksSuggestions,
  logoProps,
  logoLuProps,
  onInputClose,
  onInputOpen,
  onSuggestItemClick,
  onProductItemClick,
  onTopTermItemClick,
  onHeaderSuggestionLinkClick,
  onZipCodeClick,
  onClickPopperBtn,
  popperDisplay,
  onClosePopper,
  onSearch,
  onTypeSearch,
  onLogout,
  onLogoClick,
  onMenuItemClick,
  customLoginMenu,
  onHorizontalLinksClick,
  onHoverZipCode,
  onClickSearchEvent,
  onUnsignedClick,
  onSignedHover,
  onSignedMenuClick,
  onClickWishlist,
  onHoverMenuItem,
  onClickMenuItem
}) => {
  var _headerData$logo, _headerData$logo2, _headerData$logo3, _headerData$logo4, _linksSuggestions$lin, _headerData$search;

  const {
    account,
    headerData,
    companyLinks,
    contactLinks,
    login,
    wishlist,
    bag,
    zipcode
  } = data;

  const handleMenuItemClick = (e, link, selectedSubmenu, menuType) => {
    onMenuItemClick(e, link, selectedSubmenu, menuType);
  };

  return /*#__PURE__*/React.createElement(HeaderContainer, {
    "data-testid": "header-elem"
  }, /*#__PURE__*/React.createElement(HeaderContent, null, /*#__PURE__*/React.createElement(LuContainer, {
    href: (headerData == null ? void 0 : (_headerData$logo = headerData.logo) == null ? void 0 : _headerData$logo.url) || '/',
    role: "link",
    "aria-label": (headerData == null ? void 0 : (_headerData$logo2 = headerData.logo) == null ? void 0 : _headerData$logo2.ariaLabel) || 'ir para página inicial',
    onClick: onLogoClick,
    "data-testid": "logo-lu-magalu"
  }, logoLuProps ? /*#__PURE__*/React.createElement(GenericImageIcon, logoLuProps) : /*#__PURE__*/React.createElement(LogoMagaluDesktop, {
    titleAccess: "Logo Lu",
    width: 95,
    height: 113
  })), /*#__PURE__*/React.createElement(LogoContainer, {
    href: (headerData == null ? void 0 : (_headerData$logo3 = headerData.logo) == null ? void 0 : _headerData$logo3.url) || '/',
    role: "link",
    "aria-label": (headerData == null ? void 0 : (_headerData$logo4 = headerData.logo) == null ? void 0 : _headerData$logo4.ariaLabel) || 'ir para página inicial',
    onClick: onLogoClick,
    "data-testid": "logo-magalu"
  }, /*#__PURE__*/React.createElement(StyledLogo, logoProps)), /*#__PURE__*/React.createElement(LinksContainer, null, /*#__PURE__*/React.createElement(HorizontalLinks, {
    data: companyLinks,
    handleHorizontalLinksClick: onHorizontalLinksClick
  }), /*#__PURE__*/React.createElement(HorizontalLinks, {
    data: contactLinks,
    handleHorizontalLinksClick: onHorizontalLinksClick
  })), /*#__PURE__*/React.createElement(WidgetsContainer, null, /*#__PURE__*/React.createElement(SearchInputContainer, {
    hasSibling: (linksSuggestions == null ? void 0 : (_linksSuggestions$lin = linksSuggestions.links) == null ? void 0 : _linksSuggestions$lin.length) > 1
  }, /*#__PURE__*/React.createElement(SearchInput, {
    initialValue: initialValue,
    onSearch: onSearch,
    onTypeChange: onTypeSearch,
    onSuggestItemClick: onSuggestItemClick,
    onProductItemClick: onProductItemClick,
    onTopTermItemClick: onTopTermItemClick,
    onClickSearchEvent: onClickSearchEvent,
    onInputClose: onInputClose,
    onInputOpen: onInputOpen,
    placeholder: headerData == null ? void 0 : (_headerData$search = headerData.search) == null ? void 0 : _headerData$search.placeholder,
    list: searchSuggestions.terms,
    products: searchSuggestions.products,
    desktopMode: true,
    topTerms: topTermsData,
    onMenuItemClick: handleMenuItemClick
  }), /*#__PURE__*/React.createElement(HeaderLinks, {
    isRendered: isRendered,
    data: linksSuggestions,
    onClick: onHeaderSuggestionLinkClick
  })), /*#__PURE__*/React.createElement(LoggedAreaContainer, null, customLoginMenu ? /*#__PURE__*/React.createElement(React.Fragment, null, customLoginMenu) : /*#__PURE__*/React.createElement(LoginMenu, _extends({}, login, account, {
    onLogout: onLogout,
    onUnsignedClick: onUnsignedClick,
    onSignedHover: onSignedHover,
    onSignedMenuClick: onSignedMenuClick
  }))), (zipcode == null ? void 0 : zipcode.showZipcode) && /*#__PURE__*/React.createElement(Zipcode, _extends({}, zipcode, {
    popperDisplay: popperDisplay,
    onZipCodeClick: onZipCodeClick,
    onClickPopperBtn: onClickPopperBtn,
    onClosePopper: onClosePopper,
    onHoverZipCode: onHoverZipCode
  })), (wishlist == null ? void 0 : wishlist.href) && /*#__PURE__*/React.createElement(ButtonContainer, {
    href: wishlist == null ? void 0 : wishlist.href,
    "data-testid": "wishlist-button-container",
    onClick: onClickWishlist
  }, /*#__PURE__*/React.createElement(StyledWishlistCounterButton, _extends({
    truncateAmountThreshold: 99
  }, wishlist))), /*#__PURE__*/React.createElement(ButtonContainer, {
    href: bag == null ? void 0 : bag.href,
    "data-testid": "bag-button-container"
  }, /*#__PURE__*/React.createElement(StyledShoppingBagButton, _extends({
    truncateAmountThreshold: 99
  }, bag)))), /*#__PURE__*/React.createElement(MenusContainer, null, /*#__PURE__*/React.createElement(LinksMenu, {
    data: data,
    onMenuItemClick: handleMenuItemClick,
    onHoverMenuItem: onHoverMenuItem,
    onClickMenuItem: onClickMenuItem
  })), /*#__PURE__*/React.createElement(StyledStrip, {
    size: 5,
    position: "relative"
  })));
};

Header.defaultProps = {
  customLoginMenu: null,
  data: {
    account: {},
    headerData: {},
    companyLinks: {},
    contactLinks: {},
    categoryList: {},
    specialLinks: [],
    externalLinks: [],
    allCategories: {},
    login: {},
    wishlist: {},
    bag: {}
  },
  searchSuggestions: {
    terms: [],
    products: []
  },
  linksSuggestions: {
    links: [],
    title: ''
  },
  logoProps: {},
  isRendered: bool,
  initialValue: '',
  onInputClose: () => {},
  onInputOpen: () => {},
  onLogout: () => {},
  onSuggestItemClick: () => {},
  onProductItemClick: () => {},
  onTopTermItemClick: () => {},
  onZipCodeClick: () => {},
  onMenuItemClick: () => {},
  onHoverZipCode: () => {},
  onClickWishlist: () => {},
  onHorizontalLinksClick: () => {},
  onUnsignedClick: () => {},
  onSignedHover: () => {},
  onSignedMenuClick: () => {},
  onClickSearchEvent: () => {},
  onHeaderSuggestionLinkClick: () => {},
  onHoverMenuItem: () => {},
  onClickMenuItem: () => {}
};
process.env.NODE_ENV !== "production" ? Header.propTypes = {
  customLoginMenu: oneOfType([element, string, node]),
  data: shape({
    account: shape({
      signOutUrl: string
    }),
    headerData: shape({
      logo: shape({
        url: string,
        ariaLabel: string
      }),
      search: shape({
        placeholder: string
      })
    }),
    companyLinks: object,
    contactLinks: object,
    categoryList: object,
    specialLinks: array,
    externalLinks: array,
    allCategories: object,
    login: object,
    wishlist: shape({
      href: string
    }),
    bag: shape({
      href: string
    })
  }),
  logoProps: object,
  logoLuProps: shape({
    href: string,
    height: string,
    width: string,
    viewBox: string
  }),
  isRendered: bool,
  searchSuggestions: shape({
    terms: arrayOf(object),
    products: arrayOf(object)
  }),
  topTermsData: shape({
    list: arrayOf(shape({
      term: string,
      index: number
    })),
    label: string,
    shouldDisplay: bool
  }),
  linksSuggestions: shape({
    links: arrayOf(shape({
      href: string,
      value: string
    })),
    title: string
  }),
  initialValue: string,
  onSearch: func.isRequired,
  onTypeSearch: func.isRequired,
  onInputClose: func,
  onInputOpen: func,
  onSuggestItemClick: func,
  onProductItemClick: func,
  onTopTermItemClick: func,
  onMenuItemClick: func,
  onLogout: func,
  onLogoClick: func.isRequired,
  onZipCodeClick: func,
  onHoverZipCode: func,
  onClickWishlist: func,
  onClickBag: func,
  onClickPopperBtn: func,
  onHorizontalLinksClick: func,
  onHoverMenuItem: func,
  onClickMenuItem: func,
  onUnsignedClick: func,
  onSignedHover: func,
  onSignedMenuClick: func,
  onClickSearchEvent: func,
  onHeaderSuggestionLinkClick: func,
  onClosePopper: func,
  popperDisplay: oneOf(['info', 'success', null])
} : void 0;
export default Header;